import { useEffect } from "react";
import { API } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";

const matchTopic = (topic, patterns) =>
  !patterns?.length || patterns.some((pattern) => topic === pattern || topic.startsWith(`${pattern}:`));

export const useAdminRealtime = (onUpdate, patterns = []) => {
  const { user } = useAuth();
  const patternKey = patterns.join("|");

  useEffect(() => {
    if (!user || typeof EventSource === "undefined") return undefined;
    const token = localStorage.getItem("kelifa_token");
    if (!token) return undefined;

    const source = new EventSource(`${API}/admin/events?token=${encodeURIComponent(token)}`);

    const handler = (event) => {
      try {
        const data = JSON.parse(event.data || "{}");
        const activePatterns = patternKey ? patternKey.split("|") : [];
        if (matchTopic(data.topic, activePatterns)) onUpdate?.(data);
      } catch (_) {
        // Ignore malformed realtime payloads; polling/fallback UI remains safe.
      }
    };

    source.addEventListener("update", handler);
    return () => source.close();
  }, [user, onUpdate, patternKey]);
};
